import { Deserializable } from '../protocols/deserializable';
import { FundType } from '../transactions/fund-type';

export class InvestmentInstructionSubmissionInstructionData implements Deserializable {
  public fundId!: number;
  public fund!: FundType;
  public accountId!: number | null;
  public percentage!: number;

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;

    if (!!this.fund) {
      this.fund = Deserialize.instanceOf(FundType, this.fund);
    }
  }
}
